import React, { useState } from 'react'
import { Card, CardBody, Col, Nav, NavItem, NavLink } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { Badges, Btn } from '../../../../AbstractElements';
import { AddLabel, ComposeEmail, EmailFilter, Href } from '../../../../Utils/Constants';
import { RootState } from '../../../../ReduxToolkit/Store';
import { setComposeEmail, setModal } from '../../../../ReduxToolkit/Reducers/LetterBoxReducer';
import { letterBoxSidebar } from '../../../../Data/Applications/LetterBox';
import DashboardSvgIcon from '../../../../Utils/CommonComponents/DashboardSvgIcon';
import { useLetterBoxFilter } from '../../../../Features/letterBox/context/FilterContext';

export interface LetterBoxNavType {
    navId: string;
    setNavId: (key: string) => void;
    actives: number;
    deleted: number;
    favourite: number;
}

export default function LetterLeftAside({ navId, setNavId, actives, deleted, favourite }: LetterBoxNavType) {
    const dispatch = useDispatch()
    const queryClient = useQueryClient();
    const { composeEmail, inboxEmail, modal, interviewEmail } = useSelector((state: RootState) => state.email);
    const { setStatus, setSelectNumber } = useLetterBoxFilter();
    let starBadges = inboxEmail.filter((data) => data.star === true && 1)
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const nav_value: Record<string, number> = {
        Inbox: actives,
        Starred: favourite,
        Trash: deleted,
    };
    const handleNavClick = (id: string, title: string) => {
        setNavId(id);
        setSelectNumber(undefined);
        switch (title) {
            case "Inbox":
                setStatus("not_deleted");
                break;
            case "Trash":
                setStatus("deleted");
                break;
            case "Starred":
                setStatus("favourite");
                break;
            default:
                break;
        }
        queryClient.invalidateQueries({ queryKey: ["letterBox-list"], exact: false });
    };

    return (
        <Col xxl={3} xl={4} className={`box-col-12 ${interviewEmail ? "d-none" : ""}`}>
            <div className="md-sidebar d-none">
                <Btn color='primary' className="md-sidebar-toggle" onClick={toggle}>{EmailFilter}</Btn>
                <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen ? 'open' : ''}`}>
                    <div className="email-left-aside">
                        <Card>
                            <CardBody>
                                <div className="email-app-sidebar">
                                    <Btn color='primary' className="emailbox" onClick={() => dispatch(setComposeEmail(!composeEmail))}>
                                        <i className="fa-solid fa-plus" />{ComposeEmail}
                                    </Btn>
                                    <Nav className="main-menu email-category" pills>
                                        {letterBoxSidebar.map((data) => (
                                            <NavItem key={data.id}>
                                                <NavLink className={navId === data.id ? "active" : ""} id={data.id} onClick={() => handleNavClick(data.id, data.title)} href={Href}>
                                                    <DashboardSvgIcon className={`stroke-icon ${data.color ? `stroke-${data.color}` : ""}`} iconId={data.icon} />
                                                    <div>
                                                        {data.title}
                                                        {data.badge && (
                                                        <Badges color="transparent">
                                                            {nav_value[data.title] ?? 0}
                                                        </Badges>
                                                        )}
                                                    </div>
                                                </NavLink>
                                            </NavItem>
                                        ))}
                                        {/* <NavItem>
                                            <NavLink className="btn" href={Href} onClick={() => dispatch(setModal(!modal))}>
                                                <i className="fa-solid fa-plus" />{AddLabel}
                                            </NavLink>
                                        </NavItem> */}
                                    </Nav>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        </Col>
    )
}
